import { APP_INITIALIZER, NgModule } from '@angular/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatCardModule } from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from "ng-recaptcha";
import { ToastrModule } from 'ngx-toastr';
import { MatRadioModule } from '@angular/material/radio';

import { AppComponent } from './app.component';
import { ConfigurationService } from './services/configuration.service';
import { ReservationFormComponent } from './components/reservation-form/reservation-form.component';
import { ReservationConfirmComponent } from './components/reservation-confirm/reservation-confirm.component';
import { ReservationCalendarComponent } from './components/reservation-form/reservation-calendar/reservation-calendar.component';
import { ReservationTimesComponent } from './components/reservation-form/reservation-times/reservation-times.component';
import { ReservationQuestionaireComponent } from './components/reservation-form/reservation-questionaire/reservation-questionaire.component';
import { ReservationCategorySelectComponent } from './components/reservation-form/reservation-category-select/reservation-category-select.component';
import { ReservationHeaderComponent } from './components/reservation-header/reservation-header.component';
import { SubmitReservationComponent } from './components/reservation-form/submit-reservation/submit-reservation.component';
import { ReservationPluginService } from './services/reservation-plugin.service';
import { ReservationWcagComponent } from './reservation-wcag/reservation-wcag.component';

export function initializerFactory(appConfig: ConfigurationService) {
  return () => appConfig.loadAppConfig();
};

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/');
}

@NgModule({
  declarations: [
    AppComponent,
    ReservationFormComponent,
    ReservationConfirmComponent,
    ReservationCalendarComponent,
    ReservationTimesComponent,
    ReservationQuestionaireComponent,
    ReservationCategorySelectComponent,
    ReservationHeaderComponent,
    SubmitReservationComponent,
    ReservationWcagComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
      }
    }),
    MatDatepickerModule,
    MatNativeDateModule,
    MatGridListModule,
    MatCardModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
    RecaptchaV3Module,
    ToastrModule.forRoot({
      positionClass: 'toast-bottom-right'
    }),
    MatRadioModule
  ],
  providers: [
    ConfigurationService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializerFactory,
      multi: true,
      deps: [ConfigurationService],
    },
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useFactory: (reservationService: ReservationPluginService) => {
        return reservationService.getRecaptchaKey();
      },
      deps: [ReservationPluginService]
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
